import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import moment from 'moment';
import Constants from "../../Constants";

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data: { 
        
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData();
    },
    methods: {
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        educationResourceListData() {
            return _.get(this, 'contentData.educationResourceListData', []) || [];
        },
        systemJournalListData() {
            return _.get(this, 'contentData.systemJournalListData', []) || [];
        },
        firstDescription() {
            let description = _.get(this, 'form.HasDescriptions', []) || [];
            return description[0];
        },
        secondDescription() {
            let description = _.get(this, 'form.HasDescriptions', []) || [];
            return description[1];
        },
        thirdDescription() {
            let description = _.get(this, 'form.HasDescriptions', []) || [];
            return description[2];
        },
    }, // end of computed
}).$mount('#app');